import { NotificationTypeDto } from './notification-type-dto.model';


export class AllInstructionDto implements IAllInstructionDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    type!: NotificationTypeDto;
    createdOn!: Date | undefined;
    pageLink!: string | undefined;

    constructor(data?: IAllInstructionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.type = _data["type"] ? NotificationTypeDto.fromJS(_data["type"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.pageLink = _data["pageLink"];
        }
    }

    static fromJS(data: any): AllInstructionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllInstructionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["pageLink"] = this.pageLink;
        return data; 
    }
}

export interface IAllInstructionDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    type: NotificationTypeDto;
    createdOn: Date | undefined;
    pageLink: string | undefined;
}

